import FsLightbox from "fslightbox-react";
import { useState } from "react";

const KYouthProgramFramework = () => {
  const [toggler, setToggler] = useState(false);
  return (
    <div
      id="program-framework"
      style={{
        scrollMarginBlockStart: 500,
      }}
      className="eduvibe-home-four-about edu-about-area about-style-2 edu-section-gapBottom bg-color-white"
    >
      <div className="container">
        <div className="inner">
          <div className="thumbnail">
            <img
              src={`${process.env.PUBLIC_URL}/k-youth/assets/process.png`}
              alt="Program Framework"
              onClick={() => setToggler(!toggler)}
            />
          </div>
        </div>
        <FsLightbox
          toggler={toggler}
          sources={[`${process.env.PUBLIC_URL}/k-youth/assets/process.png`]}
        />
      </div>
    </div>
  );
};

export default KYouthProgramFramework;
